<app-timeline [auditLogs]="items" (scrolledToBottom)="onScrollToBottom($event)"></app-timeline>
